import { useSortable } from '@dnd-kit/sortable';

import Icon from 'components/common/Icons/base/Icon/Icon';

import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/EditBulkActionRulesPage/Cells/rowDragHandleCell.module.scss';

export const RowDragHandleCell = ({ rowId }: { rowId: string }) => {
    const { attributes, listeners } = useSortable({
        id: rowId,
    });
    return (
        <div {...attributes} {...listeners} className={classes.container}>
            <Icon name={'reorder-widget'} size={'1.8rem'} title={'Reorder Widget'} />
        </div>
    );
};
